import React, { useMemo } from 'react';
import DropDown from '../dropdown';
import PropTypes from 'prop-types';
import { useTextResources } from '../../../language';
import { EntityType } from '../constants';

const EntityTypesDropDown = ({ entityTypeIds = [], ...rest }) => {
  const text = useTextResources();
  const data = useMemo(() => {
    const data = []
    for (const key in EntityType) {
      if (entityTypeIds.length && !entityTypeIds.includes(EntityType[key])) {
        continue
      } else {
        data.push({
          text: text(key),
          value: EntityType[key]
        })
      }
    }

    return data;
  }, [entityTypeIds])

  return (
    <DropDown
      textField='text'
      valueField='value'
      data={data}
      {...rest}
    />
  );
};

EntityTypesDropDown.propTypes = {
  entityTypeIds: PropTypes.array,
  onChange: PropTypes.func,
};

export default EntityTypesDropDown;
